import { DesignProject } from "@yardzen/api-dtos";
import { AxiosResponse } from "axios";
import { apiClient } from "../base-client";

const baseUrl = "accounts";

export async function getOnboardingStatus(
  accountId: string,
  designProjectId: string,
): Promise<AxiosResponse<DesignProject>> {
  return apiClient.get(
    `${baseUrl}/${accountId}/design-projects/${designProjectId}/onboarding`,
  );
}
